import styled from 'styled-components';
import Card from '@material-ui/core/Card';
import Colors from '../../constants/color';

export const Elevation = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 15px;
  margin-bottom: 15px;
  margin-right: 10px;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  width: 320px;
`;

export const List = styled.div`
  display: flex;
  cursor: pointer;
  flex-direction: column;
  justify-content: space-between;
  width: 320px;
`;
export const ContainerImage = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;
export const ContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  height: 80px;
  margin-top: 20px;
  margin-bottom: 10px;
  margin-left: 25px;
`;
export const PDV = styled.div`
  height: 50;
  border-radius: 30px;
  font-size: 10px;
  text-align: center;
  padding-top: 4px;
  padding-bottom: 2px;
  color: grey;
  width: 40px;
  font-weight: bold;
  border: 2px solid ${Colors.grey3};
`;
export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0px 10px 15px 10px;
`;
export const ContainerCount = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 35px;
  width: 80px;
  background-color: ${Colors.grey6};
  border-radius: 40px;
`;
export const PlaceName = styled.strong`
  font-family: 'Graphik-Semibold';
  word-break: keep-all;
`;
export const Small = styled.small`
  font-size: 12px;
  margin-top: 10px;
  color: ${Colors.grey2} ;
  font-family: 'Graphik-Regular';
  text-transform: capitalize;
  word-break: keep-all;
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 14px;
`;
